import { render, staticRenderFns } from "./gestion_buro_transunion.vue?vue&type=template&id=7a7ed60e&scoped=true"
import script from "./gestion_buro_transunion.vue?vue&type=script&lang=js"
export * from "./gestion_buro_transunion.vue?vue&type=script&lang=js"
import style0 from "./gestion_buro_transunion.vue?vue&type=style&index=0&id=7a7ed60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7ed60e",
  null
  
)

export default component.exports